import React, { useState, useEffect, useRef } from 'react';

const THX_RED = '#B71530';

const PRESETS = [
  { label: '7 Days',  value: '7'  },
  { label: '14 Days', value: '14' },
  { label: '30 Days', value: '30' },
  { label: '60 Days', value: '60' },
];

export function toIso(d) {
  return d.toISOString().split('T')[0];
}

export function calcRange(days) {
  const to   = new Date();
  const from = new Date();
  from.setDate(from.getDate() - parseInt(days, 10));
  return { from: toIso(from), to: toIso(to) };
}

function fmtDisplay(iso) {
  if (!iso) return '–';
  try {
    return new Date(iso + 'T00:00:00').toLocaleDateString('en-GB', {
      day: 'numeric', month: 'short', year: 'numeric',
    });
  } catch { return iso; }
}

const btnBase = {
  borderRadius: '20px', padding: '4px 14px', fontSize: '12px',
  fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s',
};

export default function PeriodFilter({ preset, dateFrom, dateTo, onPresetChange, onFromChange, onToChange }) {
  // Local state for immediate visual feedback while the user types
  const [localFrom, setLocalFrom] = useState(dateFrom);
  const [localTo,   setLocalTo]   = useState(dateTo);
  const fromTimer = useRef(null);
  const toTimer   = useRef(null);

  // Sync local inputs when parent changes dates (e.g. preset click)
  useEffect(() => { setLocalFrom(dateFrom); }, [dateFrom]);
  useEffect(() => { setLocalTo(dateTo);     }, [dateTo]);

  // Cleanup timers on unmount
  useEffect(() => () => {
    clearTimeout(fromTimer.current);
    clearTimeout(toTimer.current);
  }, []);

  const handleFromChange = (e) => {
    const val = e.target.value;
    setLocalFrom(val);
    clearTimeout(fromTimer.current);
    fromTimer.current = setTimeout(() => onFromChange({ target: { value: val } }), 500);
  };

  const handleToChange = (e) => {
    const val = e.target.value;
    setLocalTo(val);
    clearTimeout(toTimer.current);
    toTimer.current = setTimeout(() => onToChange({ target: { value: val } }), 500);
  };

  return (
    <div
      className="card mb-3"
      style={{ border: '1px solid #e9ecef', borderRadius: '10px', background: '#fafbfc', marginTop: '8px' }}
    >
      <div className="card-body py-2">
        <div className="d-flex align-items-center flex-wrap gap-3">

          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: '11px', fontWeight: 700, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.6px', whiteSpace: 'nowrap' }}>
              <i className="bi bi-calendar-range me-1" />Period
            </span>
            {PRESETS.map(p => (
              <button
                key={p.value}
                style={{
                  ...btnBase,
                  backgroundColor: preset === p.value ? THX_RED : '#fff',
                  color:           preset === p.value ? '#fff'   : '#495057',
                  border:          preset === p.value ? `1px solid ${THX_RED}` : '1px solid #ced4da',
                  boxShadow:       preset === p.value ? '0 2px 6px rgba(183,21,48,0.25)' : 'none',
                }}
                onClick={() => onPresetChange(p.value)}
              >
                {p.label}
              </button>
            ))}
          </div>

          <div style={{ width: '1px', height: '28px', backgroundColor: '#dee2e6', flexShrink: 0 }} />

          <div className="d-flex align-items-center gap-2 flex-wrap">
            <span style={{ fontSize: '11px', fontWeight: 700, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.6px', whiteSpace: 'nowrap' }}>
              <i className="bi bi-calendar3 me-1" />Custom
            </span>
            <div className="d-flex align-items-center gap-1">
              <label style={{ fontSize: '12px', color: '#6c757d', marginBottom: 0, whiteSpace: 'nowrap' }}>From</label>
              <input type="date" className="form-control form-control-sm"
                style={{ width: '145px', fontSize: '12px', borderRadius: '6px' }}
                value={localFrom}
                max={localTo || toIso(new Date())}
                onChange={handleFromChange} />
            </div>
            <div className="d-flex align-items-center gap-1">
              <label style={{ fontSize: '12px', color: '#6c757d', marginBottom: 0, whiteSpace: 'nowrap' }}>To</label>
              <input type="date" className="form-control form-control-sm"
                style={{ width: '145px', fontSize: '12px', borderRadius: '6px' }}
                value={localTo}
                min={localFrom}
                max={toIso(new Date())}
                onChange={handleToChange} />
            </div>
          </div>

          <div style={{ marginLeft: 'auto' }}>
            <span style={{ fontSize: '12px', color: '#495057', backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: '6px', padding: '3px 10px', whiteSpace: 'nowrap' }}>
              <i className="bi bi-funnel me-1" style={{ color: THX_RED }} />
              {fmtDisplay(dateFrom)} &ndash; {fmtDisplay(dateTo)}
            </span>
          </div>

        </div>
      </div>
    </div>
  );
}
